module.exports = __webpack_public_path__ + "static/img/iot2.c19b2ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/iot2.png
// module id = fPJ4
// module chunks = 0